import React from "react";
import IndependentVPNIcon from "../../assets/icons/IndependentVPN.svg";
import ValtIcon from "../../assets/icons/valt-icon.svg";
import MeileIcon from "../../assets/icons/meile.svg";
import SentinelIcon from "../../assets/icons/SentinelVPN.svg";
import SolarIcon from '../../assets/icons/SolarDVPN.svg';
import NorseIcon from "../../assets/icons/norse-logo.svg";


import VPNCard from "../../components/Cards/VPNCard";
import SentinelMobileImg from "../../assets/images/sentinel-mobile.png";
import BagimsizMobileImg from "../../assets/images/bagimsiz-mobile.png";
import MeileMobileImg from "../../assets/images/meile-dvpn-mobile.png";
import ValtMobileImg from "../../assets/images/valt-mobile.png";
import SolarMobileImg from '../../assets/images/solar-mobile.png'
import NorseMobileImg from '../../assets/images/norse-mobile.png'
import DVPNBotMobileImg from '../../assets/images/dvpnbot-mobile.png'


const elements = [
  <VPNCard
    title={"Sentinel Shield dVPN"}
    subtitle={"Explore Sentinel Shield dVPN"}
    img={SentinelMobileImg}
    details={{
      icon: SentinelIcon,
      android: "https://play.google.com/store/apps/details?id=co.sentinel.dvpnapp",
      ios: "https://apps.apple.com/app/sentinel-shield-dvpn/id6657986086",
    }}
  />,
  <VPNCard
    title={"Independent VPN"}
    subtitle={"Explore Independent VPN"}
    img={BagimsizMobileImg}
    details={{
      icon: IndependentVPNIcon,
      android: "https://play.google.com/store/apps/details?id=com.bagimsizvpn.app&pli=1",
      ios: "https://apps.apple.com/us/app/independent-vpn/id6468454526",
      folder: "https://bagimsizvpn.com",
    }}
  />,
  <VPNCard
    title={"Meile dVPN"}
    subtitle={"Explore Meile dVPN"}
    img={MeileMobileImg}
    details={{
      icon: MeileIcon,
      mac: "https://mathnodes.com/index.php/meile-dvpn-client-linux-os-x/",
      windows: "https://github.com/MathNodes/meile-gui/releases/download/v1.8.0/Meile.exe",
      linux: "https://mathnodes.com/index.php/meile-dvpn-client-linux-os-x/",
    }}
  />,
  <VPNCard
    title={"VALT"}
    subtitle={"Explore VALT"}
    img={ValtMobileImg}
    details={{
      icon: ValtIcon,
      android: "https://play.google.com/store/apps/details?id=com.hashcash.breadcrumbs&pli=1",
      ios: "https://apps.apple.com/us/app/valt-personal-data-manager/id1630660373",
      folder: "https://valtdata.com/app-download/",
    }}
  />,
  <VPNCard
    title={"Solar dVPN"}
    subtitle={"Explore Solar dVPN"}
    img={SolarMobileImg}
    details={{
      icon: SolarIcon,
      android: "https://play.google.com/store/apps/details?id=ee.solarlabs.dvpn",
      ios: "https://apps.apple.com/us/app/solar-dvpn-fast-anonymous/id1597909295",
      folder: "https://dvpn.solar/",
    }}
  />,
  <VPNCard
    title={"DVPN by NORSE"}
    subtitle={"Explore DVPN by NORSE"}
    img={NorseMobileImg}
    details={{
      icon: NorseIcon,
      android: "",
      ios: "",
      folder: "https://norselabs.io/products/dvpn",
    }}
  />,
  <VPNCard
    title={"DVPN Bot"}
    subtitle={"Explore DVPN Bot"}
    img={DVPNBotMobileImg}
    details={{
      icon: NorseIcon,
      android: "https://t.me/dvpnbot",
      ios: "https://t.me/dvpnbot",
      folder: "https://norselabs.io/products/dvpn-bot",
    }}
  />,
];

export default elements;
